import {IProductStoreEventContext, TAddToCartPoint} from 'modules/analytics/types/ProductSnippetAnalytics';

// Элемент $.eventContext для «Показа товара», «Клика на товар с переходом на PDP»
// и «Добавления товара в корзину» (см. «Разметка. PLP. Сниппет»).
// quantity_stores_available не передаётся, если винотек нет.
export const buildProductStoreEventContext = (
    storeEventContext: IProductStoreEventContext,
    addToCartPoint?: TAddToCartPoint,
) => ({
    // eslint-disable-next-line @typescript-eslint/naming-convention
    is_only_in_stores: storeEventContext.isOnlyInStores,
    ...(0 < storeEventContext.storesWithStockCount && {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        quantity_stores_available: String(storeEventContext.storesWithStockCount),
    }),
    ...(addToCartPoint && {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        add_to_cart_point: addToCartPoint,
    }),
});
